<div id="bonussystem-container" class="ya-typography" (swiperight)="navigateBack()">
  <ya-subheader [hasContent]="true" [disableNavigateBack]="true" (onNavigateBackClick)="navigateBack()">
    <div class="header-action-container">
      <div class="header-action-item">
        <a matRipple matRippleCentered="true" (click)="openFilterDialog()" matBadge="!" matBadgeSize="small"
          [matBadgeHidden]="locationFilterIds.length===0">
          <div class="inline-icon hyp-filter-svg" inlineSVG="shop-icons.svg#ya-hypersoft-standort"></div>
        </a>
      </div>
    </div>
  </ya-subheader>
  <div [@bonusButtonEntering]="isLoaded" class="ya-page-content ya-page-content--webshop">
    <ng-container *ngIf="userWebvoucherViewModel.webvoucherQRCode">
      <div class="ya-page-content ya-page-content--padding ya-page-content--webshop ya-page-content--qr">
        <div class="ya-item-list-container">
          <div class="ya-content-item qr-button animation" (click)="openQRCodeDialog()">
            <div class="bonus-content-wrapper bonus-qr-content-wrapper">
              <div class="bonus-page-content-header ya-detail-page-header">
                <div id="headerTitleContainer" class="ya-page-content-header">
                  <h2 class="title" langkey="phBonusAction_Your_QR"></h2>
                </div>
              </div>
              <p>
                <span langkey="phBonusAction_QR_Text"></span>
              </p>
            </div>
            <div class="container">
              <div class="qrcode-container">
                <div class="qrcode-svg-wrapper">
                  <div class="qr-code" [innerHTML]="wevoucherqrcodesvg"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="showCreateQRCodeHint">
      <div class="ya-page-content ya-page-content--padding ya-page-content--webshop ya-page-content--qr">
        <div class="ya-item-list-container">
          <div class="ya-content-item qr-button animation" (click)="navigateToCreateWebvoucher()">
            <div class="bonus-content-wrapper bonus-qr-content-wrapper">
              <div class="bonus-page-content-header ya-detail-page-header">
                <div id="headerTitleContainer" class="ya-page-content-header">
                  <h2 class="title" langkey="phBonusAction_Create_QR"></h2>
                </div>
              </div>
              <p>
                <span langkey="phBonusAction_Create_QR_Text"></span>
              </p>
            </div>
            <div class="container">
              <div class="qrcode-container">
                <div class="qrcode-svg-wrapper">
                  <div class="qr-code qr-code--placeholder">
                    <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-qr"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="hasData; then pageTemplate else emptyTemplate"></ng-container>
    <ng-template #pageTemplate>
      <div class="ya-page-content ya-page-content--webshop">
        <div class="bonus-tabs">
          <mat-tab-group mat-stretch-tabs dynamicHeight="true" animationDuration="20ms">
            <mat-tab label="bonus">
              <div class="ya-page-content ya-page-content--padding ya-page-content--webshop">
                <div class="ya-item-list-container">
                  <ng-container *ngFor="let bonusActionViewModel of bonusActionViewModelList">
                    <div class="ya-content-item bonus-item bonus-button animation">
                      <ng-container *ngIf="!isRegistered">
                        <div class="member-icon">
                          <span langkey="phCoupon_Members"></span>
                          <div class="inline-icon hyp-filter-svg" inlineSVG="shop-icons.svg#ya-hypersoft-user-single">
                          </div>
                        </div>
                      </ng-container>
                      <div class="bonus-content-wrapper">
                        <div class="bonus-content">
                          <div class="bonus-page-content-header ya-detail-page-header">
                            <div id="headerTitleContainer" class="ya-page-content-header"
                              (click)="navigateToBonusActionDetail(bonusActionViewModel.id)">
                              <h2>{{bonusActionViewModel.labelDE}}</h2>
                            </div>
                            <div class="bonus-like">
                              <ya-favoritebutton [likeStatus]="bonusActionViewModel.like"
                                [contentType]="contentType.Bonussystem" [likeStatus]="bonusActionViewModel.like"
                                [modelId]="bonusActionViewModel.id">
                              </ya-favoritebutton>
                            </div>
                          </div>
                          <ng-container *ngIf="hasDescription(bonusActionViewModel.description)">
                            <div class="bonus-description"
                              (click)="navigateToBonusActionDetail(bonusActionViewModel.id)">
                              <p [innerHTML]="bonusActionViewModel.description"> </p>
                            </div>
                          </ng-container>
                          <div class="bonus-content-header ya-detail-page-header">
                            <div id="headerTitleContainer" class="bonus-detail-title">
                              <h2 langkey="phBonusAction_Benefits"></h2>
                            </div>
                            <ng-container *ngIf="isRegistered && bonusActionViewModel.hasValidPoints">
                              <div class="total-points">
                                <p langkey="phBonusAction_Current_Points"></p>
                                <p>{{bonusActionViewModel.points}}</p>
                              </div>
                            </ng-container>
                          </div>
                          <ng-container *ngIf="isRegistered && bonusActionViewModel.hasPointsLoadingError">
                            <p class="notice--error" langkey="phBonusAction_Load_Points_Error"></p>
                          </ng-container>
                          <ng-container *ngIf="showPointsInBasketLabel(bonusActionViewModel.pointsInBasket)">
                            <div class="bonus-redeem--info">
                              <span
                                [innerHTML]="pointsInBasketLabel(bonusActionViewModel.points,bonusActionViewModel.pointsInBasket)"></span>
                            </div>
                          </ng-container>
                          <div class="item-column-container">
                            <ng-container *ngFor="let benefit of bonusActionViewModel.benefits">
                              <div class="item-column-container__item">
                                <div class="ya-content-item bonus-button">
                                  <div class="articleCard articleCard--has-image"
                                    (click)="handleBenefitRedemption(benefit, bonusActionViewModel)">
                                    <div class="image-container">
                                      <div class="aspect-ratio-box">
                                        <div class="aspect-ratio-box-inside">
                                          <div class="aspect-ration-img-box">
                                            <img class="ya_image" [src]="benefit.image_photo" alt="" />
                                          </div>
                                        </div>
                                      </div>
                                      <div class="benefit-cost">
                                        <span>{{createBonusActionPointsText(benefit.cost)}}</span>
                                      </div>
                                    </div>
                                    <div class="content-container">
                                      <div class="product-label-content">
                                        <div>
                                          <h3>
                                            {{benefit.label_de}}
                                          </h3>
                                        </div>
                                      </div>
                                      <div class="content-lower-bar">
                                        <ng-container *ngIf="isRegistered">
                                          <ng-container [ngSwitch]="getBenefitStatus(benefit, bonusActionViewModel)">
                                            <ng-container *ngSwitchCase="benefitState.Collect">
                                              <div class="point-circle counting">
                                                <div class="inline-icon hyp-filter-svg"
                                                  inlineSVG="shop-icons.svg#ya-hypersoft-bonus"></div>
                                                <svg viewBox="0 0 46 46" class="circular-chart points">
                                                  <path class="circle-bg"
                                                    d="M23 7.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                                                  <path class="circle"
                                                    [style.stroke-dasharray]="benefit.benefitpercantage + ', 100'"
                                                    d="M23 7.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                                                </svg>
                                              </div>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="benefitState.Redeem">
                                              <span class="circle-text" langkey="phBonusAction_Redeem_Benefits"></span>
                                              <div class="point-circle redeem-circle">
                                                <div class="inline-icon hyp-filter-svg"
                                                  inlineSVG="shop-icons.svg#ya-hypersoft-bonus"></div>
                                                <svg viewBox="0 0 46 46" class="circular-chart points">
                                                  <path class="circle-bg" stroke-dasharray="100, 100"
                                                    d="M23 7.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                                                  <path class="circle-line"
                                                    d="M23 7.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                                                  <path class="circle" stroke-dasharray="100, 100"
                                                    d="M23 7.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                                                </svg>
                                              </div>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="benefitState.CollectForNext">
                                              <div class="point-circle counting">
                                                <div class="inline-icon hyp-filter-svg" inlineSVG="hypersoft-bonus.svg">
                                                </div>
                                                <svg viewBox="0 0 46 46" class="circular-chart points">
                                                  <path class="circle-bg"
                                                    d="M23 7.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                                                  <path class="circle"
                                                    [style.stroke-dasharray]="benefitInBasketPercentage(benefit.cost, bonusActionViewModel.points, bonusActionViewModel.pointsInBasket) + ', 100'"
                                                    d="M23 7.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                                                </svg>
                                              </div>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="benefitState.RedeemAgain">
                                              <span class="circle-text" langkey="phBonusAction_Redeem_Benefits"></span>
                                              <div class="point-circle redeem-circle">
                                                <div class="inline-icon hyp-filter-svg" inlineSVG="hypersoft-bonus.svg">
                                                </div>
                                                <svg viewBox="0 0 46 46" class="circular-chart points">
                                                  <path class="circle-bg" stroke-dasharray="100, 100"
                                                    d="M23 7.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                                                  <path class="circle-line"
                                                    d="M23 7.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                                                  <path class="circle" stroke-dasharray="100, 100"
                                                    d="M23 7.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                                                </svg>
                                              </div>
                                            </ng-container>
                                          </ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="!isRegistered">
                                          <span class="circle-text" langkey="phBonusAction_Register_Benefits"></span>
                                          <div class="point-circle not-reg-circle">
                                            <div class="inline-icon hyp-filter-svg" inlineSVG="shop-icons.svg#ya-lock">
                                            </div>
                                            <svg viewBox="0 0 46 46" class="circular-chart points">
                                              <path class="circle-bg" d="M23 7.0845
                                                  a 15.9155 15.9155 0 0 1 0 31.831
                                                  a 15.9155 15.9155 0 0 1 0 -31.831" />
                                              <path class="circle" stroke-dasharray="100, 100" d="M23 7.0845
                                                  a 15.9155 15.9155 0 0 1 0 31.831
                                                  a 15.9155 15.9155 0 0 1 0 -31.831" />
                                            </svg>
                                          </div>
                                        </ng-container>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                      <div class="benefit-bottom" (click)="navigateToBonusActionDetail(bonusActionViewModel.id)">
                        <div class="menugroup-item__bar">
                          <div class="menugroup-item__label">
                            <h3 langkey="phBonusAction_To_Benefits"></h3>
                          </div>
                          <div class="menugroup-item__forwardicon">
                            <div class="inline-icon" inlineSVG="shop-icons.svg#ya-keyboard_backspace"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </ng-template>
    <ng-template #emptyTemplate>
      <ya-emptypage></ya-emptypage>
    </ng-template>
  </div>
</div>